import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-date-filter-new',
  standalone: false,
  templateUrl: './date-filter-new.component.html',
  styleUrl: './date-filter-new.component.scss'
})
export class DateFilterNewComponent implements IFilterAngularComp {

  params!: IFilterParams;

  // Because CustomAdapter converts date to epoch
  fromDate: any = null;
  toDate: any = null;

  agInit(params: IFilterParams): void {

    this.params = params;

    const today = new Date();

    // Today 12:00 AM
    const startOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      0,
      0,
      0,
      0
    ).valueOf();

    // Today 11:59:59 PM
    const endOfDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      23,
      59,
      59,
      999
    ).valueOf();

    // Adapter automatically handles conversion
    this.fromDate = startOfDay;
    this.toDate = endOfDay;

    // Apply default filter initially
    setTimeout(() => {
      this.params.filterChangedCallback();
    });
  }

  isFilterActive(): boolean {
    return this.fromDate !== null || this.toDate !== null;
  }

  doesFilterPass(params: any): boolean {

    const cellValue = this.params.getValue(params.node);

    if (!cellValue) return false;

    const startTs = this.fromDate
      ? new Date(this.fromDate).setHours(0, 0, 0, 0)
      : null;

    const endTs = this.toDate
      ? new Date(this.toDate).setHours(23, 59, 59, 999)
      : null;

    if (startTs && endTs) {
      return cellValue >= startTs && cellValue <= endTs;
    }

    if (startTs) return cellValue >= startTs;

    if (endTs) return cellValue <= endTs;

    return true;
  }

  getModel(): any {

    if (!this.isFilterActive()) return null;

    const fromEpoch = this.fromDate
      ? new Date(this.fromDate).setHours(0, 0, 0, 0)
      : null;

    const toEpoch = this.toDate
      ? new Date(this.toDate).setHours(23, 59, 59, 999)
      : null;

    return {
      filter: `${fromEpoch},${toEpoch}`
    };
  }

  setModel(model: any): void {

    if (!model) {
      this.fromDate = null;
      this.toDate = null;
      return;
    }

    this.fromDate = model.fromDate || null;
    this.toDate = model.toDate || null;
  }

  onSubmit() {

    this.params.filterChangedCallback();


  }

  onClear() {

    this.fromDate = null;
    this.toDate = null;

    this.params.filterChangedCallback();
  }
}